import EventEmitter from 'events';

export const AppEvents = {
  FINISH_REHYDRATE_STORE: 'FINISH_REHYDRATE_STORE',
  UPLOAD_ATTEMPT: 'UPLOAD_ATTEMPT',
};
class AppEventHandler extends EventEmitter {
  emitFinishRehydrateStore() {
    this.emit(AppEvents.FINISH_REHYDRATE_STORE);
  }
  emitUploadAttempt() {
    this.emit(AppEvents.UPLOAD_ATTEMPT);
  }
}

const appEventHandler = new AppEventHandler();

export default appEventHandler;



// WEBPACK FOOTER //
// ./src/modules/storeMountCheck.js